export default {
  GET_PARTICIPATIONS_STATISTICS_REQUEST: '@@participations/GET_PARTICIPATIONS_STATISTICS_REQUEST',
  GET_PARTICIPATIONS_STATISTICS_SUCCESS: '@@participations/GET_PARTICIPATIONS_STATISTICS_SUCCESS',
  GET_PARTICIPATIONS_STATISTICS_ERROR: '@@participations/GET_PARTICIPATIONS_STATISTICS_ERROR',

  GET_SOURCES_STATISTICS_REQUEST: '@@participations/GET_SOURCES_STATISTICS_REQUEST',
  GET_SOURCES_STATISTICS_SUCCESS: '@@participations/GET_SOURCES_STATISTICS_SUCCESS',
  GET_SOURCES_STATISTICS_ERROR: '@@participations/GET_SOURCES_STATISTICS_ERROR',
};
